module.exports = __webpack_public_path__ + "media/6s-Ahmed-Zulfiqar-Bio.6a098f0b.mp4";